import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=34bd695a&scoped=true"
import script from "./widget.vue?vue&type=script&lang=js"
export * from "./widget.vue?vue&type=script&lang=js"
import style0 from "./widget.vue?vue&type=style&index=0&id=34bd695a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bd695a",
  null
  
)

export default component.exports